import Smartlook from "smartlook-client";

export const track = (eventName: string) => {
  Smartlook.track(eventName, {});
};
